import { Checkbox, Flex, Text } from '@shared/components';
import { useFormContext } from 'react-hook-form';

import { useCheckboxState } from '../hooks';
import { type QBankStructureCVForm, CheckboxType } from '../types';
import { getCheckboxIconByType } from '../utils';

interface QBankStructureCVHeaderProps {
  selectAllProps?: {
    disabled?: boolean;
    hidden?: boolean;
  };
}

export function QBankStructureCVHeader(props: Readonly<QBankStructureCVHeaderProps>) {
  const { selectAllProps: { disabled: isDisabled = false, hidden: isHidden = false } = {} } = props;
  const formContext = useFormContext();
  const data: QBankStructureCVForm['contentIds'] = formContext.watch('contentIds', {});
  const [{ isChecked, checkboxState }, setCheckboxState] = useCheckboxState(data);

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;

    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        if (data[key].isVisible !== isChecked) {
          data[key].isVisible = isChecked;
        }
      }
    }

    formContext.setValue('contentIds', { ...data }, { shouldDirty: true });

    setCheckboxState(isChecked ? CheckboxType.Checked : CheckboxType.Unchecked);
  };

  return (
    <Flex sx={{ alignItems: 'center', justifyContent: 'space-between', mb: 4 }}>
      <Text variant='h4'>Visibility Settings</Text>
      {isHidden ? null : (
        <Checkbox
          label='Select All'
          onChange={handleSelectAll}
          disabled={isDisabled}
          value={isChecked}
          checkedIcon={getCheckboxIconByType(checkboxState)}
        />
      )}
    </Flex>
  );
}
